import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useContentfulEntries } from '../../../hooks';
import {
  SYSTEM_UNAVAILABLE_BANNER_KEY,
  SYSTEM_UNAVAILABLE_CONTENT_TYPE,
  SYSTEM_UNAVAILABLE_OPERATING_SYSTEM,
} from '../../../services/contentful.constants';

const useDownBanner = () => {
  const { i18n } = useTranslation();

  const { data, loading } = useContentfulEntries({
    contentType: SYSTEM_UNAVAILABLE_CONTENT_TYPE,
    key: SYSTEM_UNAVAILABLE_BANNER_KEY,
    query: {
      'fields.enabled': true,
      'fields.language': i18n.language,
      'fields.operatingSystem': SYSTEM_UNAVAILABLE_OPERATING_SYSTEM,
    },
  });

  const bannerContent = useMemo(() => {
    if (!data?.items?.[0]?.fields) {
      return { subtitle: '', title: '' };
    }

    const { title, subtitle } = data.items[0].fields;

    return {
      subtitle: String(subtitle),
      title: String(title),
    };
  }, [data]);

  return {
    bannerContent,
    downBannerLoading: loading,
    downBannerVisible: Boolean(bannerContent.title && bannerContent.subtitle),
  };
};

export { useDownBanner };
